import React from 'react';
import { IoMdCloseCircle } from 'react-icons/io';
import { ClearButtonContainer } from './styles';

const ClearCellButton = ({ onClick }) => {
  const handleClick = (event) => {
    event.stopPropagation();
    onClick();
  };

  return (
    <ClearButtonContainer
      type="button"
      className="fleet-cell-clear-btn"
      onClick={handleClick}
      onMouseDown={(event) => event.stopPropagation()}
      title="Remover valor"
      aria-label="Remover valor"
    >
      <IoMdCloseCircle size={16} />
    </ClearButtonContainer>
  );
};

export default ClearCellButton;
